import { getTemplateTemplateScaffoldStyles } from './OrganizationInfo.styles'

const t = document.createElement('template')
t.innerHTML = `
<div class="organization-info-frame-inner">
  <div class="organization-info-frame-sub-name-wrapper">
    <slot name="organizationName"></slot>
  </div>
  <span part="separator"></span>
  <div class="organization-info-frame-sub-number-wrapper">
    <slot name="contractNumber"></slot>
  </div>
</div>
`

class OrganizationInfo extends HTMLElement {
  static get observedAttributes() {
    return ['variant']
  }

  connectedCallback() {
    const shadow = this.attachShadow({ mode: 'open' })
    shadow.appendChild(getTemplateTemplateScaffoldStyles().content.cloneNode(true))
    shadow.appendChild(t.content.cloneNode(true))

    const orgSlot = shadow.querySelector('slot[name="organizationName"]')
    const contractSlot = shadow.querySelector('slot[name="contractNumber"]')

    orgSlot?.addEventListener('slotchange', () => this.updateSlotState())
    contractSlot?.addEventListener('slotchange', () => this.updateSlotState())

    this.updateSlotState()
  }

  attributeChangedCallback(name: string) {
    if (name === 'variant') {
      this.updateSlotState()
    }
  }

  private updateSlotState() {
    const orgText = this.querySelector('[slot="organizationName"]')?.textContent?.trim()
    const contractText = this.querySelector('[slot="contractNumber"]')?.textContent?.trim()

    const hasOrg = Boolean(orgText)
    const hasContract = Boolean(contractText)

    this.toggleAttribute('no-org', !hasOrg)
    this.toggleAttribute('no-contract', !hasContract)

    const separator = this.shadowRoot?.querySelector('[part="separator"]')
    if (!separator) return

    separator.textContent =
      hasOrg && hasContract && this.getAttribute('variant') === 'utility-menu' ? ' · ' : ''
  }
}

if (!customElements.get('ts-organization-info')) {
  customElements.define('ts-organization-info', OrganizationInfo)
}

export { OrganizationInfo }
